//removeIf(production)
import ClaroluzEvents from "../../../../../infra/critical/claroluz-events";
import ClaroluzNotifyEmail from "../../../../../external/datasources/claroluz-notify-email";
//endRemoveIf(production)

function noOffersSubmit() {
    document.querySelectorAll('.no-offers-form-submit').forEach(element => {
        element.addEventListener('click', () => {
            let hasError = false;
            let emailElement = document.querySelector('.no-offers-form-email') as HTMLInputElement;
            let emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            let cups = document.querySelector('.no-offers-form-cups') as HTMLInputElement;

            if (!emailRegex.test(emailElement.value)) {
                emailElement.classList.add('has-error');

                hasError = true;
            } else {
                emailElement.classList.remove('has-error');
            }

            if (!document.querySelector('.claroluz-nooffers-checkbox .claroluz-checkbox--checkbox:checked')) {
                document.querySelector('.claroluz-nooffers-checkbox')?.classList.add('has-error');

                hasError = true;
            } else {
                document.querySelector('.claroluz-nooffers-checkbox')?.classList.remove('has-error');
            }

            if (!hasError) {
                document.querySelector('.claroluz-nooffers-form-group')?.classList.add('display-none');
                document.querySelector('.no-offers-form-submit')?.classList.add('display-none');
                document.querySelector('.claroluz-nooffers-success')?.classList.remove('display-none');
            }

            new ClaroluzEvents(appProperties(), 'comparator', 'no-offers', 'send-email', emailElement.value);
            new ClaroluzNotifyEmail(emailElement.value, cups.value);
        });
    });
}
noOffersSubmit();

//removeIf(production)
function appProperties(): import("../../../../../infra/critical/claroluz-events-properties").default {
    throw new Error("Function not implemented.");
}
//endRemoveIf(production)
